import useApiError from "../../hooks/useApiError";

export function Error() {
    const { error } = useApiError();
    return (
        <>
            <div className="container">
                <div className="d-flex align-items-center justify-content-center vh-50">
                    <div className="row"><h1 className="display-1 fw-bold">{error && error.status && (error.status.status)}</h1></div>
                    <div className="row mt-4 ml-4"><p>{error && error.status && (error.status.statusText)}...</p></div>
                </div>
                <div className="d-flex align-items-center justify-content-center vh-50">
                    <div className="row mt-4 ml-4 fw-bold"><p>If this keeps happening please contact an administrator...</p></div>
                </div>
            </div>
        </>
    )
}